import TextInput from "./TextInput";

function App() {
  return (
    <div className="App">
      <TextInput />
    </div>
  );
}

export default App;
